/**
 * The countries an agent works with us in, as guests read them
 * (`agents.st_region`, agent window, 2026-10-05): both, Malaysia only, or
 * Singapore only. Letters, Super Transfers messages, hotel emails and the
 * guest page all narrow "Malaysia & Singapore" to the one country. The
 * server applies the same rules in `AgentBranding.cs` (Region / ForRegion).
 */
import { countriesPhrase, countryName } from '@/shared/geo/countries';

export type AgentRegion = 'mysg' | 'my' | 'sg';

/** `agents.st_region` as the choice: 'my' / 'sg', anything else both. */
export function agentRegionOf(column: string | null | undefined): AgentRegion {
  const r = (column ?? '').trim().toLowerCase();
  return r === 'my' || r === 'sg' ? r : 'mysg';
}

/**
 * The countries as printed after the company or agent name: the one country
 * of a single-country agent, else every country the tenant operates in
 * ("Malaysia & Singapore" for Asian Trails, "Thailand" for a company in one
 * country), from the running geography.
 */
export function regionName(region: AgentRegion): string {
  return region === 'my' ? countryName('MY') : region === 'sg' ? countryName('SG') : countriesPhrase('&');
}

/** "Malaysia & Singapore" in a name or sign-off, narrowed to the region's one country. */
export function forRegion(text: string, region: AgentRegion): string {
  return region === 'mysg'
    ? text
    : text.replace(/\bmalaysia\s*(?:&|and)\s*singapore\b/gi, regionName(region));
}

/** Whether a page or letter shows that country's contact line. */
export const showsMalaysia = (region: AgentRegion) => region !== 'sg';
export const showsSingapore = (region: AgentRegion) => region !== 'my';
